import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.find";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/focuscycler
 */
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
/**
 * A utility class that helps cycling over focusable {@link module:ui/view~View views} in a
 * {@link module:ui/viewcollection~ViewCollection} when the focus is tracked by the
 * {@link module:utils/focustracker~FocusTracker} instance. It helps implementing keyboard
 * navigation in HTML forms, toolbars, lists and the like.
 *
 * To work properly it requires:
 * * a collection of focusable (HTML `tabindex` attribute) views that implement the `focus()` method,
 * * an associated focus tracker to determine which view is focused.
 *
 * A simple cycler setup can look like this:
 *
 *		const focusables = new ViewCollection();
 *		const focusTracker = new FocusTracker();
 *
 *		// Add focusable views to the focus tracker.
 *		focusTracker.add( ... );
 *
 * Then, the cycler can be used manually:
 *
 *		const cycler = new FocusCycler( { focusables, focusTracker } );
 *
 *		// Will focus the first focusable view in #focusables.
 *		cycler.focusFirst();
 *
 *		// Will log the next focusable item in #focusables.
 *		console.log( cycler.next );
 *
 * Alternatively, it can work side by side with the {@link module:utils/keystrokehandler~KeystrokeHandler}:
 *
 *		const keystrokeHandler = new KeystrokeHandler();
 *
 *		// Activate the keystroke handler.
 *		keystrokeHandler.listenTo( sourceOfEvents );
 *
 *		const cycler = new FocusCycler( {
 *			focusables, focusTracker, keystrokeHandler,
 *			actions: {
 *				// When arrowup of arrowleft is detected by the #keystrokeHandler,
 *				// focusPrevious() will be called on the cycler.
 *				focusPrevious: [ 'arrowup', 'arrowleft' ],
 *			}
 *		} );
 */

var FocusCycler = /*#__PURE__*/function () {
  /**
   * Creates an instance of the focus cycler utility.
   *
   * @param {Object} options Configuration options.
   * @param {module:utils/collection~Collection|Object} options.focusables
   * @param {module:utils/focustracker~FocusTracker} options.focusTracker
   * @param {module:utils/keystrokehandler~KeystrokeHandler} [options.keystrokeHandler]
   * @param {Object} [options.actions]
   */
  function FocusCycler(options) {
    var _this = this;

    _classCallCheck(this, FocusCycler);

    Object.assign(this, options);
    /**
     * A {@link module:ui/view~View view} collection that the cycler operates on.
     *
     * @readonly
     * @member {module:utils/collection~Collection} #focusables
     */

    /**
     * A focus tracker instance that the cycler uses to determine the current focus
     * state in {@link #focusables}.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker} #focusTracker
     */

    /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
     * which can respond to certain keystrokes and cycle the focus.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler} #keystrokeHandler
     */

    /**
     * Actions that the cycler can take when a keystroke is pressed. Requires
     * `options.keystrokeHandler` to be passed and working. When an action is
     * performed, `preventDefault` and `stopPropagation` will be called on the event
     * the keystroke fired in the DOM.
     *
     *		actions: {
     *			// Will call #focusPrevious() when arrowleft or arrowup is pressed.
     *			focusPrevious: [ 'arrowleft', 'arrowup' ],
     *
     *			// Will call #focusNext() when arrowdown is pressed.
     *			focusNext: 'arrowdown'
     *		}
     *
     * @readonly
     * @member {Object} #actions
     */

    if (options.actions && options.keystrokeHandler) {
      var _loop = function _loop(methodName) {
        var actions = options.actions[methodName];

        if (typeof actions == 'string') {
          actions = [actions];
        }

        var _iterator = _createForOfIteratorHelper(actions),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var keystroke = _step.value;
            options.keystrokeHandler.set(keystroke, function (data, cancel) {
              _this[methodName]();

              cancel();
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      for (var methodName in options.actions) {
        _loop(methodName);
      }
    }
  }
  /**
   * Returns the first focusable view in {@link #focusables}.
   * Returns `null` if there is none.
   *
   * @readonly
   * @member {module:ui/view~View|null} #first
   */


  _createClass(FocusCycler, [{
    key: "focusFirst",

    /**
     * Focuses the {@link #first} item in {@link #focusables}.
     */
    value: function focusFirst() {
      this._focus(this.first);
    }
    /**
     * Focuses the {@link #last} item in {@link #focusables}.
     */

  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focus(this.last);
    }
    /**
     * Focuses the {@link #next} item in {@link #focusables}.
     */

  }, {
    key: "focusNext",
    value: function focusNext() {
      this._focus(this.next);
    }
    /**
     * Focuses the {@link #previous} item in {@link #focusables}.
     */

  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      this._focus(this.previous);
    }
    /**
     * Focuses the given view if it exists.
     *
     * @protected
     * @param {module:ui/view~View} view
     */

  }, {
    key: "_focus",
    value: function _focus(view) {
      if (view) {
        view.focus();
      }
    }
    /**
     * Returns the next or previous focusable view in {@link #focusables} with respect
     * to {@link #current}.
     *
     * @protected
     * @param {Number} step Either `1` for checking forward from {@link #current} or
     * `-1` for checking backwards.
     * @returns {module:ui/view~View|null}
     */

  }, {
    key: "_getFocusableItem",
    value: function _getFocusableItem(step) {
      // Cache for speed.
      var current = this.current;
      var collectionLength = this.focusables.length;

      if (!collectionLength) {
        return null;
      } // Start from the beginning if no view is focused.
      // https://github.com/ckeditor/ckeditor5-ui/issues/206


      if (current === null) {
        return this[step === 1 ? 'first' : 'last'];
      } // Cycle in both directions.


      var index = (current + collectionLength + step) % collectionLength;

      do {
        var view = this.focusables.get(index); // TODO: Check if view is visible.

        if (isFocusable(view)) {
          return view;
        } // Cycle in both directions.


        index = (index + collectionLength + step) % collectionLength;
      } while (index !== current);

      return null;
    }
  }, {
    key: "first",
    get: function get() {
      return this.focusables.find(isFocusable) || null;
    }
    /**
     * Returns the last focusable view in {@link #focusables}.
     * Returns `null` if there is none.
     *
     * @readonly
     * @member {module:ui/view~View|null} #last
     */

  }, {
    key: "last",
    get: function get() {
      return this.focusables.filter(isFocusable).slice(-1)[0] || null;
    }
    /**
     * Returns the next focusable view in {@link #focusables} based on {@link #current}.
     * Returns `null` if there is none.
     *
     * @readonly
     * @member {module:ui/view~View|null} #next
     */

  }, {
    key: "next",
    get: function get() {
      return this._getFocusableItem(1);
    }
    /**
     * Returns the previous focusable view in {@link #focusables} based on {@link #current}.
     * Returns `null` if there is none.
     *
     * @readonly
     * @member {module:ui/view~View|null} #previous
     */

  }, {
    key: "previous",
    get: function get() {
      return this._getFocusableItem(-1);
    }
    /**
     * An index of the view in the {@link #focusables} which is focused according
     * to {@link #focusTracker}. Returns `null` when there is no such view.
     *
     * @readonly
     * @member {Number|null} #current
     */

  }, {
    key: "current",
    get: function get() {
      var _this2 = this;

      var index = null; // There's no focused view in the focusables.

      if (this.focusTracker.focusedElement === null) {
        return null;
      }

      this.focusables.find(function (view, viewIndex) {
        var focused = view.element === _this2.focusTracker.focusedElement;

        if (focused) {
          index = viewIndex;
        }

        return focused;
      });
      return index;
    }
  }]);

  return FocusCycler;
}(); // Checks whether a view is focusable.
//
// @private
// @param {module:ui/view~View} view A view to be checked.
// @returns {Boolean}


export { FocusCycler as default };

function isFocusable(view) {
  return !!(view.focus && global.window.getComputedStyle(view.element).display != 'none');
}